var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { createContext, forwardRef, useImperativeHandle, useMemo, useCallback } from 'react';
import { useAsyncEffect, useAsyncState, wrap } from '@hilma/tools';
import Axios from 'axios';
import { useGetAccessToken } from '../hooks';
export var UserContext = createContext(null);
export var GetUserContext = createContext(null);
var UserProvider = forwardRef(function (_a, ref) {
    var children = _a.children, url = _a.url, config = _a.config, _b = _a.onFinish, onFinish = _b === void 0 ? function () { return null; } : _b, _c = _a.onNoAccessToken, onNoAccessToken = _c === void 0 ? function () { return null; } : _c, _d = _a.onError, onError = _d === void 0 ? function () { return null; } : _d;
    var _e = useAsyncState(null), user = _e[0], setUser = _e[1];
    var getAccessToken = useGetAccessToken();
    var accessToken = useMemo(getAccessToken, [getAccessToken]);
    var getUser = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var user_1, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 5, , 7]);
                    if (!!accessToken) return [3 /*break*/, 2];
                    onNoAccessToken();
                    return [4 /*yield*/, setUser(null)];
                case 1: return [2 /*return*/, _a.sent()];
                case 2: return [4 /*yield*/, Axios(url, config)];
                case 3:
                    user_1 = (_a.sent()).data;
                    return [4 /*yield*/, setUser(user_1)];
                case 4:
                    _a.sent();
                    onFinish(user_1);
                    return [2 /*return*/, user_1];
                case 5:
                    error_1 = _a.sent();
                    return [4 /*yield*/, setUser(null)];
                case 6:
                    _a.sent();
                    onError(error_1);
                    throw error_1;
                case 7: return [2 /*return*/];
            }
        });
    }); }, [accessToken]);
    useAsyncEffect(function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, getUser()];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    error_2 = _a.sent();
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); }, [getUser]);
    useImperativeHandle(ref, function () { return user; }, [user]);
    return wrap([UserContext.Provider, { value: user }], [GetUserContext.Provider, { value: getUser }])(children);
});
export default UserProvider;
//# sourceMappingURL=UserProvider.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@hilma/auth/dist/context/UserProvider.js
// module id = 25
// module chunks = 1